import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import {
  setClassesOrSeriesAction,
  setDeleteManadatedClassAction,
} from "../../../../../../store/actions/actionCreators/adminActionCreator/groupManagementActionCreator";
import {
  deleteMandatedProgramActionHandler,
  getClassAndCollectionByProgramIdActionHandler,
  mandateProgramActionHandler,
} from "../../../../../../store/actions/actionHandlers/adminActionHandler/groupManagementActionHandler";
import { setErrorHandler } from "../../../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../../../utils/errorTypes";
import CardContainer from "../CardContainer/CardContainer";
import classes from "./ManageSeries.module.scss";
import ShotclassCollection from "./ShotclassCollection/ShotclassCollection";
import { useSelector } from "react-redux";
import { frequncyNameConverter } from "../ManageMandatoryLearnings";

const SeriesList = ({
  radioBtnVal,
  seriesDetails,
  repititiveValArr,
  setValue,
  getUserGroupMandateShotClasses,
  selectVal,
}) => {
  const dispatch = useDispatch();
  const params = useParams();
  const [selectedRepetitveVal, setSelectedRepetitveVal] = useState("");
  const [selectedRadioBtnVal, setSelectedRadioBtnVal] = useState("");
  const [shotclassCollection, setShotclassCollection] = useState(null);
  const [shotclassModalOpen, setShotclassModalOpen] = useState(false);
  const adminState = useSelector((state) => state.adminReducer);
  const { groupManagementReducer } = adminState;
  const { classOrSeriesData } = groupManagementReducer;

  const onRadioChange = (e, id, frequencyName) => {
    const val = e?.target?.value;
    setSelectedRadioBtnVal(val);
    const updatedData = seriesDetails?.map((data) => {
      if (data?.Programs?.ID === id) {
        return {
          ...data,
          Programs: {
            ...data?.Programs,
            radioBtnVal: val,
            IsRepetitive: val === "Repetitive",
          },
        };
      } else return data;
    });
    dispatch(setClassesOrSeriesAction(updatedData));
    if (val === "Repetitive" && frequencyName === "NONE") {
      setValue(`repetitive${id}`, "Monthly");
    }
  };

  const handleDelete = (id, name) => {
    dispatch(deleteMandatedProgramActionHandler(id, params?.userGroupId)).then(
      (response) => {
        if (response?.status === 200 && response?.data) {
          dispatch(setDeleteManadatedClassAction(response?.data));
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              `Series "${
                name?.length > 30 ? name?.slice(0, 30) + "..." : name
              }" is de-linked from user group successfully`
            )
          );
        } else dispatch(setErrorHandler(errorTypes.FAIL, "failed"));
      }
    );
  };

  const onSaveClick = (data) => {
    const id = data?.ID;
    const name = data?.Name;
    if (selectedRadioBtnVal === radioBtnVal[1] || data?.IsRepetitive) {
      if (data?.selectedDropdownVal || data?.FrequencyName !== "NONE") {
        dispatch(
          mandateProgramActionHandler(
            id,
            params?.userGroupId,
            1,
            selectedRepetitveVal === ""
              ? frequncyNameConverter(data?.FrequencyName)
              : selectedRepetitveVal
          )
        ).then((response) => {
          if (response?.status === 200 && response?.data) {
            dispatch(
              setErrorHandler(
                errorTypes.SUCCESS,
                `Series "${
                  name?.length > 30 ? name?.slice(0, 30) + "..." : name
                }" is linked to user group successfully`
              )
            );
            getUserGroupMandateShotClasses("Program");
          } else dispatch(setErrorHandler(errorTypes.FAIL, "failed"));
        });
      } else {
        dispatch(setErrorHandler(errorTypes?.WARN, "Please Select Frequency"));
      }
    } else
      dispatch(
        setErrorHandler(
          errorTypes.SUCCESS,
          `Series "${
            name?.length > 30 ? name?.slice(0, 30) + "..." : name
          }" is already linked to the User group`
        )
      );
  };

  const onSelectChange = (val, id) => {
    const updatedData = classOrSeriesData?.map((data) => {
      if (data?.Programs?.ID === id) {
        return {
          ...data,
          Programs: {
            ...data?.Programs,
            selectedDropdownVal: val,
          },
        };
      } else return data;
    });
    dispatch(setClassesOrSeriesAction(updatedData));
    switch (val) {
      case "Monthly":
        setSelectedRepetitveVal("1");
        break;
      case "Quarterly":
        setSelectedRepetitveVal("2");
        break;
      case "Yearly":
        setSelectedRepetitveVal("3");
        break;
      default:
        setSelectedRepetitveVal("");
        break;
    }
  };

  const imageClick = (id) => {
    setShotclassModalOpen(true);
    dispatch(getClassAndCollectionByProgramIdActionHandler(id, "en-GB")).then(
      (response) => {
        if (response?.status === 200 && response?.data) {
          setShotclassCollection(response?.data);
        }
      }
    );
  };

  return (
    <>
      <div className={classes.seriesContainer}>
        {classOrSeriesData?.length > 0 &&
          classOrSeriesData?.map((data) => (
            <CardContainer
              selectVal={selectVal}
              data={data?.Programs}
              handleDelete={() =>
                handleDelete(data?.Programs?.ID, data?.Programs?.Name)
              }
              imageClick={() => imageClick(data?.Programs?.ID)}
              isDelete
              repititiveValArr={repititiveValArr}
              onSelectChange={onSelectChange}
              radioBtnVal={radioBtnVal}
              onRadioChange={onRadioChange}
              onSaveClick={onSaveClick}
              key={data?.Programs?.ID}
              dropDownName={`repetitive${data?.Programs?.ID}`}
              radioBtnFieldName={`priority${data?.Programs?.ID}`}
              radioBtnName={`priority${data?.Programs?.ID}`}
            />
          ))}
      </div>
      {shotclassModalOpen && (
        <ShotclassCollection
          shotclassCollection={shotclassCollection}
          shotclassModalOpen={shotclassModalOpen}
          setShotclassModalOpen={setShotclassModalOpen}
          setShotclassCollection={setShotclassCollection}
        />
      )}
    </>
  );
};

export default SeriesList;
